import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {ActivityIndicatorType} from '@Components/activity-indicator/activity-indicator.types';
import {ActivityIndicatorSize} from '@Components/activity-indicator/activity-indicator.types';
import {ActivityIndicator} from '@Components/activity-indicator/activity-indicator';
import styles from './ai-icon.module.scss';
import {noop} from '@Utils/general.util';

interface AiIconProps {
  id?: string;
  className?: string;
  iconClassName?: string;
  icon: string;
  activityIndicatorType?: ActivityIndicatorType;
  size?: IconSize;
  isActive?: boolean;
  onClick?: VoidFunction;
}

const getSizeClassName = (size: IconSize): string => {
  switch (size) {
    case IconSize.SIZE_ICON_12:
      return styles.size12;
    case IconSize.SIZE_ICON_16:
      return styles.size16;
    case IconSize.SIZE_ICON_20:
      return styles.size20;
    case IconSize.SIZE_ICON_24:
      return styles.size24;
    case IconSize.SIZE_ICON_32:
      return styles.size32;
    case IconSize.SIZE_ICON_48:
      return styles.size48;
    case IconSize.SIZE_ICON_64:
      return styles.size64;
    default:
      return styles.size24;
  }
};

export function AiIcon({
  id = '',
  className = '',
  iconClassName = '',
  icon,
  activityIndicatorType,
  size = IconSize.SIZE_ICON_24,
  isActive = false,
  onClick = noop,
}: AiIconProps): ReactElement {
  const sizeClassName = getSizeClassName(size);
  const containerClassName = `${styles.aiIconContainerStyle} ${sizeClassName} ${className}${isActive ? ' -active' : ''}`;
  const unclickable = onClick === noop;

  return (
    <div id={id} className={`${containerClassName} ${unclickable ? styles.unclickable : ''}`} onClick={onClick}>
      {activityIndicatorType ? <ActivityIndicator size={ActivityIndicatorSize.SIZE_16} type={activityIndicatorType} className={styles.activityIndicator} /> : null}
      <Icon className={`${styles.aiIcon} ${iconClassName}`} icon={icon} size={size} />
    </div>
  );
}
